import { Dialog } from "vue-app-utils-web";
import router from "@/router";

const dialog = new Dialog(router);

export default dialog;